module.exports = __webpack_public_path__ + "static/media/davidoff.74bb549a.jpg";